var utils = require( '../global/utils' );

var create_account_popup = ( function( $ ) {

	var $body,
		$popup,
		$toggles,
		open = false;

	var _init = function() {
		$body    = $( 'body' );
		$popup   = $( '#create-account-popup' );
		$toggles = $( '.open-create-account-popup' );

		if ( $toggles.length > 0 && $popup.length > 0 ) {
			_setup_triggers();
			_setup_popup_actions();
		}

		if ( $( '#content' ).hasClass( 'restrict-with-popup' ) ) {
			_setup_popup_actions();
			_setup_triggers();
			_setup_content_restrict();
		}

		$( document ).keyup( function( e ) {
			if ( e.key === "Escape" ) {
				if ( open ) {
					_close_popup();
				}
			}
		});

	};

	var _setup_content_restrict = function() {
		$( '#content *' ).on( 'click focus', function( e ) {
			e.stopImmediatePropagation();
			e.preventDefault();
			_open_popup();
		} );

		$( '#content select' ).on( 'mousedown focus', function( e ) {
			e.stopImmediatePropagation();
			e.preventDefault();
			_open_popup();
		} );

		$( '#content' ).on( "focus.spt", function(e) {
			if ( ! $this.is( $mobileMenu ) && ! $this.is( $menuItems ) ) {
				$this.blur();
				var next=$this.nextAll().find('a,input');
				if (next.length>0) next[0].focus();
			} else {
				console.log('ok',this);
				e.stopPropagation();
			}
		});
	};

	var _setup_popup_actions = function(  ) {
		_setup_signin_link();
	};

	var _setup_signin_link = function() {
		$popup.find( '.open-signin' ).on( 'click', function( e ) {
			if ( utils.viewport_size().width < 992 ) {
				return;
			}

			e.preventDefault();

			_close_popup();

			setTimeout( function() {
				$( '#login-bar' ).addClass( 'open' );
			}, 400 );
		} );
	};

	var _setup_triggers = function() {
		$toggles.on( 'click', function( e ) {
			e.preventDefault();
			_open_popup();
		} );

		$popup.on( 'click', function( e ) {
			if ( ! $( e.target ).hasClass( 'exit' ) ) {
				e.stopPropagation();
			}
		} );

		$popup.find( 'exit', function( e ) {
			_close_popup( e );
		} );

		$popup.closest( '.crate-popup-wrap' ).on( 'click', _close_popup );
	};

	var _open_popup = function() {
		$( 'body' ).addClass( 'open-popup' );
		$popup.closest( '.crate-popup-wrap' ).fadeIn();

		open = true;

		// Save reference to the dialog element
		var dialog     = $popup.get( 0 ),
			focuspoint = $popup.find( '#registration_form' ).get( 0 );

		focuspoint.focus();

		// If focus moves to a control outside the dialog, move it back.
		jQuery( document ).on( "focusin.crate", function ( e ) {
			if ( ! ( $.contains( dialog, e.target ) ) ) {
				// Move focus back to dialog. That will cause this handler to fire again, but that's OK.
				focuspoint.focus();
			}
		});
	};

	var _close_popup = function( e ) {
		if ( e ) {
			e.preventDefault();
		}

		$( 'body' ).removeClass( 'open-popup' );
		$popup.closest( '.crate-popup-wrap' ).fadeOut();

		open = false;

		$( document ).off( 'focusin.crate' );
	};

	$( document ).ready( _init );

	return {
		setup_triggers: _setup_triggers,
		setup_popup_actions: _setup_popup_actions,
		open_popup: _open_popup
	};

} )( jQuery );

module.exports = create_account_popup;